function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import map from 'lodash/map';
import { getWeekdays } from 'helpers/datetime';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../../../actions';
import * as constants from '../../../../constants';
import * as selectors from '../../../../selectors';
import * as shapes from '../../../../shapes';
import messages from '../../../../messages';
import validatorRules from './validatorRules.json';
class SettingsForm extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        if (props.isInProgress !== state.isInProgress) {
            if (!props.isInProgress && !props.hasErrors) {
                return {
                    isInProgress: props.isInProgress
                };
            }
            return {
                isInProgress: props.isInProgress
            };
        }
        return null;
    }
    componentDidMount() {
        this.onPopulate();
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors, locale } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onCommit();
            this.props.onSetLocale(locale);
        }
    }
    onPopulate() {
        if (process.env.BROWSER && !this.props.isClientInitialized) {
            return;
        }
        const { settings, metricsUnits } = this.props;
        if (!settings) {
            return;
        }
        if (!settings.glucoseLevelUnitTypes) {
            settings.glucoseLevelUnitTypes = metricsUnits.bloodGlucoseConcentration;
        }
        this.onSetValues(settings);
    }
    renderCancelBtn() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            className: "btn--block",
            labelMessage: App.messages.buttons.discardChanges,
            isDisabled: this.isClean,
            onClick: ()=>this.onReset()
        });
    }
    renderSubmitBtn() {
        return /*#__PURE__*/ _jsx(Button, {
            type: "submit",
            styleModifier: "primary",
            labelMessage: App.messages.buttons.saveChanges,
            className: "btn--block btn--filled",
            isDisabled: this.isClean,
            isInProgress: this.state.isInProgress
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    "data-testid": "discard-changes-btn",
                    children: this.renderCancelBtn()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    "data-testid": "save-changes-btn",
                    children: this.renderSubmitBtn()
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(FormGroup, {
                                id: "firstDayOfWeek",
                                labelMessage: messages.labels.firstDayOfWeek,
                                formValues: this.props.formValues,
                                children: /*#__PURE__*/ _jsx(Select, {
                                    optionsFrom: map(getWeekdays(), (weekday)=>({
                                            value: weekday,
                                            label: moment().utc().day(weekday).format('dddd')
                                        })),
                                    valueKey: "value",
                                    labelKey: "label",
                                    onChange: (input)=>this.onSetValue(input)
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(FormGroup, {
                                id: "glucoseLevelUnitTypes",
                                labelMessage: messages.labels.units,
                                formValues: this.props.formValues,
                                children: /*#__PURE__*/ _jsx(Select, {
                                    optionsFrom: map(Object.keys(App.constants.BLOOD_GLUCOSE_CONCENTRATION_UNITS), (unit)=>({
                                            value: unit,
                                            label: App.constants.UNITS_SYMBOLS[unit]
                                        })),
                                    valueKey: "value",
                                    labelKey: "label",
                                    onChange: (input)=>this.onSetValue(input)
                                })
                            })
                        })
                    ]
                }),
                this.renderActions()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("section", {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.settings))
                }),
                this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = validatorRules;
        this.state = {
            isInProgress: false
        };
        if (!process.env.BROWSER) this.onPopulate();
    }
}
_define_property(SettingsForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Implicit props
    settings: shapes.settings,
    isClientInitialized: PropTypes.bool,
    locale: PropTypes.string,
    metricsUnits: PropTypes.object
}));
const mapStateToProps = (state)=>({
        settings: selectors.settings(state),
        isInProgress: selectors.isUpdateAccountSettingInProgress(state),
        hasErrors: selectors.hasUpdateAccountSettingsErrors(state),
        metricsUnits: selectors.metricsUnits(state),
        isClientInitialized: App.selectors.isClientInitialized(state),
        formValues: App.selectors.formSelector(constants.SETTINGS_FORM)(state),
        locale: App.selectors.locale(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.SETTINGS_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.updateAccountSettings(values)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName)),
        onCommitForm: ()=>dispatch(App.actions.commitForm(formName)),
        onResetForm: ()=>dispatch(App.actions.resetForm(formName)),
        onSetLocale: (locale)=>dispatch(App.actions.setLocale(locale))
    };
};
const ConnectedSettingsForm = connect(mapStateToProps, mapDispatchToProps)(SettingsForm);
export default ConnectedSettingsForm;
